<!-- layout.component.html -->
<!-- @viewbid/ui app header (wired via the shell wrapper); replaces the legacy
     <vb-header-two [style_2]="true">, which is kept declared for rollback. -->
<vb-app-header-shell></vb-app-header-shell>

<!-- Main content where routed components will be rendered -->
<router-outlet></router-outlet>

<!-- @viewbid/ui app footer (wired via the shell wrapper); replaces the legacy
     <vb-footer-one [primary_style]="true">, which is kept declared for rollback. -->
<vb-app-footer-shell></vb-app-footer-shell>

<!-- Other common components if needed -->
<app-back-to-top></app-back-to-top>
<!-- <app-product-modal></app-product-modal> -->

<!-- Non-blocking connection status indicator (floats over content) -->
<vb-connection-status></vb-connection-status>
